import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/my-tasks/")({
  component: MyTasks,
});

function MyTasks() {
  useBreadcrumb([
    {
      title: "My Tasks",
      href: "/my-tasks",
      icon: getRouteIcon(MODULE_KEYS_MAP.myTasks),
    },
  ]);
  return <div>Work in progress</div>;
}
